import { v4 as uuid } from 'uuid';
import {
    createBuildingBlocksFromTemplate,
    primaryButtonGenerator,
    secondaryButtonGenerator,
    stepTextContentGenerator,
    titleGenerator,
} from '../utils/ai-template-utils';
import { AI_MOBILE_LAYOUT_TEXT } from '../utils/constants';
import { BuildingBlockLayouts } from '@pendo/services/BuildingBlocks';

const { PrebuiltLayouts } = BuildingBlockLayouts;

export const MOBILE_POPUP_STEP_TEMPLATE = {
    ARTIFACT_KEYS_TO_GENERATORS: {
        title: titleGenerator,
        stepTextContent: stepTextContentGenerator,
        buttons: {
            primaryButton: primaryButtonGenerator,
            secondaryButton: secondaryButtonGenerator,
        },
    },
};

export function createFirstMobileArtifactStep () {
    return {
        primaryButton: AI_MOBILE_LAYOUT_TEXT.PRIMARY_CTA,
        stepTextContent: AI_MOBILE_LAYOUT_TEXT.BODY,
        title: AI_MOBILE_LAYOUT_TEXT.TITLE,
    };
}

export function createArtifactStepsFromMobileAnnouncementTemplate () {
    return [createFirstMobileArtifactStep()];
}

export function createMobileAnnouncementStepTemplate ({ theme, platform, width = 360, stepArtifact = {}, stepBlocks }) {
    const artifactKeysToGenerators = MOBILE_POPUP_STEP_TEMPLATE.ARTIFACT_KEYS_TO_GENERATORS;

    const buildingBlocks =
        stepBlocks || PrebuiltLayouts.MobileLayouts.createMobilePopUpBlank(uuid(), theme, { platform });

    return createBuildingBlocksFromTemplate({
        theme,
        width,
        buildingBlocks,
        stepArtifact,
        platform,
        artifactKeysToGenerators,
    });
}
